/* eslint-disable no-console */
export default (message) => {
  if (window.console && typeof console.warn === 'function') {
    console.warn(message);
  }
};
